import styled from "@emotion/styled";
import { RelayCommand, theme } from "Application";
import { Box, Button, Input, Label } from "Components";
import { CloseIcon } from "Styles/ThemedPrimitives/Style1/CloseIcon";
import React from "react";
import { MentorWeeklyRotaViewModel } from "../MentorWeeklyRotaViewModel";
import { observer } from "mobx-react-lite";

const Container = styled.div`
    padding: 25px 20px;
    label {
        margin-top: 0;
    }
`;

const Footer = styled.div``;

const ButtonGroup = styled.div`
    padding: 30px 0 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px 30px;
    Button {
        width: 100%;
        margin-bottom: 0;
        height: 40px;
        border-radius: 5px;
    }
`;

const StyledDialog = styled.dialog`
    max-width: 500px;
    width: calc(100% - 50px);
    padding: 0;
    background: ${theme.palette.common.white};
    box-shadow: 0 0 5px rgba(101, 110, 119, 0.2);
    border: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    &:focus {
        border: none;
        outline: none;
    }

    &::backdrop {
        background: rgba(224, 228, 232, 0.9);
        animation: 0.4s ease fade;
    }

    &[open] {
        animation: 0.2s linear slidein;
    }

    @keyframes slidein {
        from {
            transform: translate3d(0, 5px, 0) translate(-50%, -50%);
        }
        to {
            transfrom: translate3d(0, 0, 0) translate(-50%, -50%);
        }
    }

    @keyframes fade {
        from {
            opacity: 0.3;
        }
        to {
            opacity: 1;
        }
    }
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fcd21d;
    padding: 12px 20px;
    font: normal normal bold 18px/24px Open Sans;
    letter-spacing: 0px;
    color: #000000;
    font-family: OpenSans-CondBold;
    button {
        width: auto !important;
        height: auto !important;
        min-height: auto;
    }
`;

export interface IProps {
    onCancel: () => void;
    viewModel: MentorWeeklyRotaViewModel;
    onConfirm: () => void;
}

const MentorStudentAttendanceModal: React.FC<IProps> = observer((props: IProps) => {
    const viewModel = props.viewModel;

    const mentorStudentAttendanceModalCloseCommand = new RelayCommand(() => {
        props.onCancel();
        viewModel.model.planForSession = "";
    });

    const confirmStudentAttendance = new RelayCommand(() => {
        props.onConfirm();
    });

    return (
        <>
            <StyledDialog open={true} style={{ zIndex: 1 }}>
                <Header>
                    Confirm Attendance <CloseIcon onClick={() => mentorStudentAttendanceModalCloseCommand.execute()} />
                </Header>
                <Container>
                    <Box mb="20px">
                        <Label
                            style={{
                                font: "normal normal normal 14px/19px Open Sans",
                                letterSpacing: "-0.21px",
                                color: "#000000",
                            }}
                        >
                            {"Student: "}
                            <strong>
                                {viewModel.model.selectedStudentAbsense?.firstName} {viewModel.model.selectedStudentAbsense?.lastName}
                            </strong>
                        </Label>
                    </Box>
                    <Box>
                        <Input
                            multiline={true}
                            rows={5}
                            displayName="Plan for session*"
                            validationMessage={() => viewModel.getError("planForSession")}
                            command={viewModel.updatePlanForSessionCommand}
                            value={() => viewModel.getValue("planForSession")}
                            placeholder="Enter the plan for this session..."
                        />
                    </Box>
                    <Footer>
                        <ButtonGroup style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <Button
                                command={confirmStudentAttendance}
                                displayName={"CONFIRM ATTENDANCE"}
                                paletteColor="primary"
                                style={{ height: "40px", width: "100%", minHeight: "40px" }}
                            />
                            <Button
                                command={mentorStudentAttendanceModalCloseCommand}
                                displayName={"CANCEL"}
                                paletteColor="secondary"
                                style={{ height: "40px", width: "100% ", minHeight: "40px" }}
                            />
                        </ButtonGroup>
                    </Footer>
                </Container>
            </StyledDialog>
        </>
    );
});

export default MentorStudentAttendanceModal;
